export const DIAGNOSTICO_STATUS_TYPE = {
  QUEIMA_CAIXA: "QUEIMA_CAIXA",
  RISCO_ASSUMIDO: "RISCO_ASSUMIDO",
  CORRETO: "CORRETO",
  A_OTIMIZAR: "A_OTIMIZAR",
};
